import React from 'react';
import BaseFileIcon from '../BaseFileIcon';

const XlsxIcon = ({ color = '#0e886b', text = 'XLSX', x = -2 }) => (
  <BaseFileIcon color={color} text={text} x={x} />
);

export default XlsxIcon;
